import create from 'zustand'

const useStore = create((set) => ({
    popupState: null,
    setPopupState: (popupState) => set(() => ({ popupState: popupState })),
}))

export const useGlobalStore = useStore
